"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var ListCard_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/card/ListCard"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importDefault(require("react"));
var constants_1 = __importDefault(require("../../../config/constants"));
var styles_2 = require("../styles");
var DrawCard = function (_a) {
    var image = _a.image, description = _a.description, name = _a.name, iconName = _a.iconName, onClick = _a.onClick, banner = _a.banner, showYellowBackground = _a.showYellowBackground, promotionType = _a.promotionType, promotionProgressivePrize = _a.promotionProgressivePrize;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.styles)(theme)();
    var cornerIcon = {
        icon: iconName,
        iconType: 'custom',
        contentColor: (banner === null || banner === void 0 ? void 0 : banner.styleType) === 'GrayedOut'
            ? theme.palette.text.disabled
            : showYellowBackground
                ? package_1.config.themeColors.cornerColors.rewardContrast.hex()
                : package_1.config.themeColors.cornerColors.promotionContrast.hex(),
        trianglePosition: { top: 0, left: 0 },
        triangleType: 'topLeft',
        triangleBackgroundColor: showYellowBackground
            ? package_1.config.themeColors.cornerColors.reward.hex()
            : package_1.config.themeColors.cornerColors.promotion.hex(),
        triangleSize: 88
    };
    return (react_1.default.createElement(ListCard_1.default, { classes: classes, image: image, imageTitle: name, text: name, textDescription: description, onClick: onClick, cornerIcon: constants_1.default.DISABLE_DRAWS_CORNER_ICON ? undefined : cornerIcon, contentClass: classes.cardContent, showBanner: banner && banner.showBanner, bannerText: banner && banner.bannerText ? banner.bannerText : undefined, bannerStyleType: banner && banner.styleType ? banner.styleType : undefined, promotionType: promotionType, promotionProgressivePrize: promotionProgressivePrize }));
};
exports.default = DrawCard;
//# sourceMappingURL=DrawCard.js.map